export const filterDuplicatesForProperty = <T>(
  array: Array<T>,
  property: keyof T,
) => {
  const seenElements = new Set()
  return array.filter((element) => {
    if (!seenElements.has(element[property])) {
      seenElements.add(element[property])
      return true
    }
    return false
  })
}

export const filterDuplicatesByProperties = <T>(
  array: Array<T>,
  property1: keyof T,
  property2: keyof T,
) => {
  const uniqueValues = new Set()
  return array.filter((item) => {
    const value1 = item[property1]
    const value2 = item[property2]
    const key = value1 + "-" + value2
    if (!uniqueValues.has(key)) {
      uniqueValues.add(key)
      return true
    }
    return false
  })
}

export const groupObjectsByProperty = <T>(
  array: Array<T>,
  property: string,
) => {
  const grouped = {}

  for (const obj of array) {
    const key = obj[property]
    if (!grouped[key]) {
      grouped[key] = []
    }
    grouped[key].push(obj)
  }

  return Object.values(grouped)
}

export function hasOnly(array: Array<string | number>, value: string | number) {
  return array.length === 1 && array[0] === value
}

/**
 * return difference between {@code currentValues} and {@code previousValues}
 * Example: current = [1,2,4], previous= [1,2,5] => added= [4], removed=[5]
 * @param currentValues
 * @param previousValues
 */
export function findChangesBetween<T extends string = string>(
  currentValues: T[],
  previousValues: T[],
) {
  const removed = previousValues.filter((item) => !currentValues.includes(item))
  const added = currentValues.filter((item) => !previousValues.includes(item))

  return { added, removed }
}

/**
 * returns the intersection between the 2 arrays given
 * if one of the arrays is null or undefined, it returns the other array
 * if both are null or undefined, it returns undefined
 *
 * makes use of Set to have a 0(1) lookup
 * @param first
 * @param second
 */
export function getIntersection<T = string>(
  first: T[] | null | undefined,
  second: T[] | null | undefined,
) {
  if (!first && !second) return undefined
  if (!first && second) return second
  if (first && !second) return first

  const setB = new Set(second)
  return first?.filter((element) => setB.has(element))
}

export function addAndRemoveUniqueStrings(
  sourceString: string[],
  stringsToAdd: string[],
  stringsToRemove: string[],
): string[] {
  const resultSet = new Set(sourceString)

  stringsToAdd.forEach((str) => resultSet.add(str))
  stringsToRemove.forEach((str) => resultSet.delete(str))

  return Array.from(resultSet)
}
